import type { Testimonial } from '../types'

export const testimonials: Testimonial[] = [
  {
    id: 'test-1',
    name: 'Sarah Chen',
    role: 'CEO',
    company: 'NovaBank Inc.',
    avatar: '/images/team-02.jpg',
    content:
      'SST WebAgency transformed our digital banking platform from concept to launch with exceptional precision. Their team understood our vision immediately and delivered a product that exceeded our expectations. The user engagement metrics speak for themselves.',
    rating: 5,
  },
  {
    id: 'test-2',
    name: 'Marcus Johnson',
    role: 'Founder',
    company: 'GreenLeaf Co.',
    avatar: '/images/team-01.jpg',
    content:
      'Working with SST was a game-changer for our eCommerce business. Our conversion rate increased by 340% after the redesign. They don\'t just build websites — they build revenue-generating machines.',
    rating: 5,
  },
  {
    id: 'test-3',
    name: 'Elena Rodriguez',
    role: 'Marketing Director',
    company: 'MediConnect Health',
    avatar: '/images/team-04.jpg',
    content:
      'The healthcare portal SST built for us is nothing short of remarkable. Patient satisfaction scores jumped 45% after launch. Their attention to accessibility and compliance made all the difference.',
    rating: 5,
  },
  {
    id: 'test-4',
    name: 'David Park',
    role: 'CTO',
    company: 'TechFlow Inc.',
    avatar: '/images/team-03.jpg',
    content:
      'SST\'s technical expertise is world-class. They architected our SaaS dashboard to handle millions of data points in real-time without breaking a sweat. A truly elite development team.',
    rating: 5,
  },
  {
    id: 'test-5',
    name: 'Aisha Mohammed',
    role: 'Brand Manager',
    company: 'Brew & Bean',
    avatar: '/images/test-05.jpg',
    content:
      'SST didn\'t just design our brand — they captured our soul. Our customers constantly compliment the cohesive experience across every touchpoint. Best investment we\'ve made.',
    rating: 5,
  },
  {
    id: 'test-6',
    name: 'James Wilson',
    role: 'Product Owner',
    company: 'EduPro Global',
    avatar: '/images/test-06.jpg',
    content:
      'The online learning platform SST delivered is incredibly robust. Our educators love the authoring tools, and students rave about the experience. Zero downtime since launch.',
    rating: 5,
  },
]
